import type { PropsWithClassName } from '@fv/client-types'

import { useBookingForm } from '../booking/hooks'
import { ShipmentBolFormField } from '../shipment-form/ShipmentBolFormField'
import { useBookingFormCtx } from './BookingFormProvider'

export const LtlBookingBolField = ({ className }: PropsWithClassName) => {
  const bolNumber = useBookingFormCtx(s => s.bolNumber)
  const loadId = useBookingFormCtx(s => s.loadId)
  const { updateBolNumber } = useBookingFormCtx(s => s.actions)
  return (
    <ShipmentBolFormField
      className={className}
      value={bolNumber ?? ''}
      onChange={updateBolNumber}
      loadId={loadId}
    />
  )
}
export const TLBookingBolField = ({ className }: PropsWithClassName) => {
  const { bolNumber, setBolNumber, loads } = useBookingForm()
  const loadId = loads[0]?.loadId
  return (
    <ShipmentBolFormField
      className={className}
      value={bolNumber ?? ''}
      onChange={setBolNumber}
      loadId={loadId}
    />
  )
}
